var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale,"auto-insert-space-in-button":false}},[_c('div',{class:[`route-name-${_vm.routerName}`],attrs:{"id":"app"}},[_c('a-spin',{attrs:{"spinning":_vm.loading,"tip":_vm.loadingTip}},[_c('router-view')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }